import { createRouter, createWebHistory } from 'vue-router';
import { ROUTER_BASE_URL } from '@/constants';

import HomeView from '@/views/home/index.vue';

const router = createRouter({
  history: createWebHistory(ROUTER_BASE_URL),
  routes: [
    {
      path: '/',
      component: HomeView,
    },
    {
      path: '/journalism/detail/:id',
      props: true,
      component: () => import('../views/journalism/detail.vue'),
      meta: {},
    },
  ],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router;
